module.exports = __webpack_public_path__ + "img/side-icon-43-off.8e203dfc.svg";